module.exports = __webpack_public_path__ + "static/media/iso37001.c6263a06.png";